module.exports = __webpack_public_path__ + "img/icon_success_small@2x.acc6b504.png";